export default "__VITE_ASSET__Dd8914vF__"